<template>
  <div class="outofstock-popup">
    <div class='outstock-img'>
      <img :src="soldoutGif"/>
    </div>
    <div class='outstock-soldout'>
      <div><span>opps~~</span></div>
      <span>商品被抢光了，下次早点来哟</span>
    </div>
    <div  class='outstock-soldout-btm'>
      <div class='outstock-txt'>
        <span class="text">是否加入收藏夹</span>
        <span class='question-d'>?</span>
      </div>
      <form @click="formSubmitRemind">
        <div class="add-btn">加入收藏夹</div>
      </form>
    </div>
  </div>
</template>

<script>
import { IMG_BASE_URL } from '@/config'

export default {
  data () {
    return {
      soldoutGif: IMG_BASE_URL + '/upaiyun/Sys/20180508/5763870670533892643.gif'
    }
  },
  methods: {
    formSubmitRemind () {
      this.$emit('formSubmitRemind')
    }
  }
}
</script>

<style scoped>
  .outofstock-popup{
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    padding: 4% 4% 0;
    bottom: 0;
    max-height: 86%;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .outstock-img{
    width: 11.5em;
    height: 11.5em;
    margin:3em auto 0;
  }
  .outstock-img img{
    width: 100%;
    height: 100%;
  }
  .outstock-soldout{
    text-align: center;
    font-weight: bold;
    margin-top:3.8em;
    line-height:2.3em;
  }
  .outstock-soldout-btm{
    display: flex;
    justify-content: space-between;
    padding:4.5% 0;
    border-top: 1px solid #eee;
    position: absolute;
    width:calc(100% - 2.3em);
    bottom:0;
    align-items: center;
  }
  .outstock-soldout-btm .add-btn{
    border-radius: 30px;
    display: block;
    overflow: inherit;
    background: #457EE8;
    color: #fff;
    padding: 5px 10px;
    cursor: pointer;
  }
  .outofstock-popup .question-d{
    margin-left:2%;
    background: #2c2c2c;
    color: #fff;
    width:1.1em;
    height: 1.1em;
    font-size: 13px !important;
    text-align: center;
    line-height: 1.1em;
    border-radius: 100%;
    display: block;
    flex-shrink: 0;
    align-self: flex-end;
  }
  .outstock-soldout-btm form{
    display:block;
  }
  .outstock-txt{
    display: flex;
  }
  .outstock-txt .text{
    display: block;
    flex-shrink: 0;
  }
</style>
